<div
  *ngIf="demoService.isOpen()"
  class="modal-backdrop fixed inset-0 z-[500] flex items-center justify-center bg-[rgba(0,9,15,0.75)] backdrop-blur-[8px] px-6 py-6 animate-[fadeIn_0.3s_ease_both]">
  <button
    type="button"
    class="absolute inset-0 w-full h-full cursor-default border-none bg-transparent"
    aria-label="Cerrar modal"
    (click)="close()">
  </button>
  <!-- Tarjeta blanca -->
  <dialog
    open
    aria-modal="true"
    aria-labelledby="demo-modal-title"
    class="bg-white rounded-[20px] w-full max-w-[520px] px-11 py-12 relative z-10 shadow-[0_40px_80px_rgba(0,0,0,0.4)] animate-[modalIn_0.4s_cubic-bezier(0.22,1,0.36,1)_both] max-h-[90vh] overflow-y-auto border-none">
    <!-- Botón cerrar -->
    <button
      type="button"
      (click)="close()"
      class="absolute top-5 right-5 w-9 h-9 rounded-full bg-[#f5f6f7] text-[#515c66] text-lg flex items-center justify-center border-none cursor-pointer transition-all duration-200 hover:bg-[#e8eaec] hover:text-[#001320]"
      aria-label="Cerrar">
      ×
    </button>

    <!-- Estado: formulario -->
    <div *ngIf="!sent">
      <!-- Eyebrow -->
      <p class="font-roboto text-[11px] font-bold tracking-[2px] uppercase text-[var(--p-green-500)] mb-2.5">
        Cuéntanos de tu propiedad
      </p>

      <!-- Título -->
      <h2 id="demo-modal-title" class="font-montserrat text-[28px] font-extrabold leading-[1.15] text-[#001320] mb-2">
        Hablemos de tu copropiedad
      </h2>

      <!-- Subtítulo -->
      <p class="font-roboto text-sm text-[#515c66] leading-relaxed mb-7">
        Te contactamos en menos de 24 horas para mostrarte cómo Convivia se adapta a tu edificio o conjunto.
      </p>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <!-- Fila 1: Nombre + Teléfono -->
        <div class="grid grid-cols-2 gap-3">
          <app-input-text
            label="Nombre"
            placeholder="Tu nombre"
            formControlName="name"
            autocomplete="name"
            [messageError]="{ required: 'Campo requerido.', minlength: 'Mínimo 2 caracteres.' }" />

          <app-input-text
            label="Teléfono"
            placeholder="+57"
            type="tel"
            formControlName="phone"
            autocomplete="tel"
            [messageError]="{ required: 'Campo requerido.', pattern: 'Número inválido.' }" />
        </div>

        <!-- Correo electrónico -->
        <app-input-text
          label="Correo electrónico"
          placeholder="tu@correo.com"
          type="email"
          formControlName="email"
          autocomplete="email"
          [messageError]="{ required: 'Campo requerido.', email: 'Ingresa un correo válido.' }" />

        <!-- Fila 2: Ciudad + Rol -->
        <div class="grid grid-cols-2 gap-3">
          <app-input-text
            label="Ciudad"
            placeholder="Ej. Bogotá"
            formControlName="city"
            [messageError]="{ required: 'Campo requerido.' }" />

          <app-input-dropdown
            label="¿Cuál es tu rol?"
            placeholder="Selecciona"
            formControlName="role"
            [filter]="false"
            [showClear]="false"
            [options]="roleOptions"
            messageError="Selecciona tu rol." />
        </div>

        <!-- Botón submit -->
        <button
          type="submit"
          [disabled]="sending"
          class="w-full flex items-center justify-center gap-2 bg-[var(--p-green-500)] text-white px-6 py-3.5 rounded-lg font-roboto text-[15px] font-semibold mt-4 transition-all duration-200 hover:bg-[#4a9a2a] hover:-translate-y-[2px] hover:shadow-[0_8px_20px_rgba(89,174,52,0.3)] disabled:opacity-60 disabled:cursor-not-allowed disabled:translate-y-0 disabled:shadow-none border-none cursor-pointer"
          aria-label="Enviar solicitud">
          <i *ngIf="sending" class="pi pi-spin pi-spinner text-sm"></i>
          <span>{{ sending ? 'Enviando...' : 'Quiero saber cómo funciona' }}</span>
        </button>

        <!-- Fine print -->
        <p class="font-roboto text-[11px] text-[#9ca3af] text-center mt-3.5 leading-relaxed">
          Al enviar aceptas nuestra
          <a
            routerLink="/legal/privacidad"
            target="_blank"
            rel="noopener"
            class="underline hover:text-[#515c66] transition-colors"
            >política de tratamiento de datos</a
          >. No spam, lo prometemos.
        </p>
      </form>
    </div>

    <!-- Estado de éxito -->
    <div *ngIf="sent" class="py-5 flex flex-col items-center text-center">
      <!-- Ícono de éxito -->
      <div
        class="w-16 h-16 rounded-full bg-[rgba(89,174,52,0.12)] text-[var(--p-green-500)] flex items-center justify-center text-[32px] mb-5 animate-[successPop_0.5s_cubic-bezier(0.22,1.5,0.36,1)_both]">
        ✓
      </div>

      <h3 class="font-montserrat text-[22px] font-extrabold text-[#001320] mb-2"> ¡Recibimos tu mensaje! </h3>
      <p class="font-roboto text-sm text-[#515c66] leading-relaxed max-w-[340px] mb-6">
        Te contactamos en menos de 24 horas para contarte cómo Convivia puede ayudar a tu copropiedad.
      </p>

      <button
        type="button"
        (click)="close()"
        class="w-full bg-[var(--p-green-500)] text-white px-6 py-3.5 rounded-lg font-roboto text-[15px] font-semibold border-none cursor-pointer transition-all duration-200 hover:bg-[#4a9a2a] hover:-translate-y-[2px] hover:shadow-[0_8px_20px_rgba(89,174,52,0.3)]"
        aria-label="Cerrar">
        Cerrar
      </button>
    </div>
  </dialog>
</div>
